/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Button, Divider, TextField, Typography } from '@material-ui/core';
import { random } from 'lodash';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import FileUpload from '../../components/molecules/FileUploadIdentity';
import AnyButton from '../../components/atoms/AnyButton';
import StepProgressBar from '../../components/atoms/StepProgressBar';
import AddMoreButton from '../../components/atoms/AddMoreButton';

const styles = theme => ({
  hidden: {
    display: 'none'
  },
  page: {
    paddingLeft: 15,
    paddingRight: 15
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    paddingTop: theme.spacing(1)
  },
  titleGroup: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'flex-start'
  },
  pagerInDiv: {
    padding: 20
  },
  mt20: {
    marginTop: 20
  },
  ml15: {
    marginLeft: 15
  },
  font16: {
    fontSize: 16
  },
  font14: {
    fontSize: 14
  },
  font12: {
    fontSize: 12
  },
  bold: {
    fontWeight: 'bold'
  },
  colorBlack: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  redText: {
    color: '#FF0000'
  },
  tableTitle: {
    fontSize: 16,
    marginBottom: '20px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #E0E0E0',
    backgroundColor: '#F7F7F7',
    width: '115px',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 700
  },
  tableCellData: {
    borderBottom: '1px solid #E0E0E0',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 500
  },
  noteText: {
    fontSize: 12,
    paddingTop: 10,
    fontWeight: 600
  },
  textLabel: {
    fontSize: 12,
    fontWeight: 600
  },
  description: {
    color: '#707070',
    fontSize: 14
  },
  linkToPrev: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20
  },
  imageInfo: {
    width: '100%',
    objectFit: 'contain'
  },
  dialog: {
    '& .MuiDialog-paper': {
      margin: 10
    }
  },
  dialogContent: {
    padding: 5
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    isReIdentity: state.accounts.reIdentity
  })),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('titleMessage', 'setTitleMessage', ''),
  withState('btnText', 'setBtnText', '入力画面に戻る'),
  withState('numberRegisterCopy', 'setNumberRegisterCopy', 1),
  withState('registerCopy', 'setRegisterCopy', []),
  withState('previewImageRegisterCopy', 'setPreviewImageRegisterCopy', []),
  withState('registerCopyType', 'setRegisterCopyType', []),
  withState('registerCopyErr', 'setRegisterCopyErr', ''),
  withState('numberSealCertificate', 'setNumberSealCertificate', 1),
  withState('sealCertificate', 'setSealCertificate', []),
  withState('previewImageSeal', 'setPreviewImageSeal', []),
  withState('sealCertificateType', 'setSealCertificateType', []),
  withState('sealCertificateErr', 'setSealCertificateErr', ''),
  withState('numberBusinessLicense', 'setNumberBusinessLicense', 1),
  withState('businessLicense', 'setBusinessLicense', []),
  withState('previewImageLicense', 'setPreviewImageLicense', []),
  withState('businessLicenseType', 'setBusinessLicenseType', []),
  withState('businessLicenseName', 'setBusinessLicenseName', []),
  withState('businessLicenseErr', 'setBusinessLicenseErr', ''),
  withState('representativeName', 'setRepresentativeName', ''),
  withState('representativeNameErr', 'setRepresentativeNameErr', ''),
  withState('representativeNameKana', 'setRepresentativeNameKana', ''),
  withState('representativeNameKanaErr', 'setRepresentativeNameKanaErr', ''),
  withState('companyCode', 'setCompanyCode', ''),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const Main = enhance(
  ({
    classes,
    show,
    isReIdentity,
    handleRedirect,
    handleBack,
    proceedToNext,
    numberRegisterCopy,
    setNumberRegisterCopy,
    registerCopy,
    setRegisterCopy,
    previewImageRegisterCopy,
    setPreviewImageRegisterCopy,
    registerCopyType,
    setRegisterCopyType,
    registerCopyErr,
    setRegisterCopyErr,
    numberSealCertificate,
    setNumberSealCertificate,
    sealCertificate,
    setSealCertificate,
    previewImageSeal,
    setPreviewImageSeal,
    sealCertificateType,
    setSealCertificateType,
    sealCertificateErr,
    setSealCertificateErr,
    numberBusinessLicense,
    setNumberBusinessLicense,
    businessLicense,
    setBusinessLicense,
    previewImageLicense,
    setPreviewImageLicense,
    businessLicenseType,
    setBusinessLicenseType,
    businessLicenseName,
    setBusinessLicenseName,
    businessLicenseErr,
    setBusinessLicenseErr,
    representativeName,
    setRepresentativeName,
    representativeNameErr,
    setRepresentativeNameErr,
    representativeNameKana,
    setRepresentativeNameKana,
    representativeNameKanaErr,
    setRepresentativeNameKanaErr,
    companyCode,
    setCompanyCode
  }) => {
    const identityParams = {
      registerCopy,
      sealCertificate,
      businessLicense,
      businessLicenseName,
      representativeName,
      representativeNameKana,
      companyCode
    };

    const validRegisterCopy = () => {
      if (
        registerCopy.length === 0 ||
        (registerCopy.length > 0 &&
          registerCopy.filter(item => !!item).length === 0)
      ) {
        setRegisterCopyErr('必須項目です。');
        return 1;
      }
      setRegisterCopyErr('');
      return 0;
    };

    const validSealCertificate = () => {
      if (
        sealCertificate.length === 0 ||
        (sealCertificate.length > 0 &&
          sealCertificate.filter(item => !!item).length === 0)
      ) {
        setSealCertificateErr('必須項目です。');
        return 1;
      }
      setSealCertificateErr('');
      return 0;
    };

    const validBusinessLicense = () => {
      // if (businessLicense.length !== businessLicenseName.length) {
      //   setBusinessLicenseErr('書類名称と画像を同時にお願いします。');
      //   return 1;
      // }
      const maxLength =
        businessLicense.length > businessLicenseName.length
          ? businessLicense.length
          : businessLicenseName.length;
      for (let i = 0; i < maxLength; i += 1) {
        const name = businessLicenseName[i]
          ? businessLicenseName[i].trim()
          : '';
        if (
          (businessLicense[i] && name === '') ||
          (!businessLicense[i] && name !== '')
        ) {
          setBusinessLicenseErr('書類名称と画像を同時にお願いします。');
          return 1;
        }
      }
      setBusinessLicenseErr('');
      return 0;
    };

    const validRepresentativeName = () => {
      const value = representativeName ? representativeName.trim() : '';
      if (value === '') {
        setRepresentativeNameErr('必須項目です。');
        return 1;
      }
      setRepresentativeNameErr('');
      setRepresentativeName(value);
      return 0;
    };

    const validRepresentativeNameKana = () => {
      const value = representativeNameKana ? representativeNameKana.trim() : '';
      if (value === '') {
        setRepresentativeNameKanaErr('必須項目です。');
        return 1;
      }
      if (!/^[\u3040-\u309F\s\d０-９ー]+$/.test(value)) {
        setRepresentativeNameKanaErr('ひらがなで入力してください。');
        return 1;
      }
      setRepresentativeNameKanaErr('');
      setRepresentativeNameKana(value);
      return 0;
    };

    const valid = () => {
      const errorCount =
        validRegisterCopy() +
        validSealCertificate() +
        validBusinessLicense() +
        validRepresentativeName() +
        validRepresentativeNameKana();
      return errorCount === 0;
    };

    const handleSetRegisterCopy = (value, index) => {
      const tmpValue = [...registerCopy];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setRegisterCopy([...tmpValue]);
    };

    const handleSetRegisterCopyType = (value, index) => {
      const tmpValue = [...registerCopyType];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setRegisterCopyType([...tmpValue]);
    };

    const handleSetPreviewImageRegisterCopy = (value, index) => {
      const tmpValue = [...previewImageRegisterCopy];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setPreviewImageRegisterCopy([...tmpValue]);
    };

    const getRegisterCopyButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberRegisterCopy; i += 1) {
        arrButton.push(
          <FileUpload
            key={random(true)}
            label={`registerCopy-${i}`}
            setFile={handleSetRegisterCopy}
            previewImage={previewImageRegisterCopy[i]}
            setPreviewImage={handleSetPreviewImageRegisterCopy}
            indexNumber={i}
            setType={handleSetRegisterCopyType}
            type={registerCopyType[i]}
          />
        );
      }
      return arrButton;
    };

    const handleSetSealCertificate = (value, index) => {
      const tmpValue = [...sealCertificate];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setSealCertificate([...tmpValue]);
    };

    const handleSetSealCertificateType = (value, index) => {
      const tmpValue = [...sealCertificateType];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setSealCertificateType([...tmpValue]);
    };

    const handleSetPreviewImageSeal = (value, index) => {
      const tmpValue = [...previewImageSeal];
      if (value) {
        tmpValue[index] = value;
      } else {
        tmpValue.splice(index, 1);
      }
      setPreviewImageSeal([...tmpValue]);
    };

    const getSealCertificateButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberSealCertificate; i += 1) {
        arrButton.push(
          <FileUpload
            key={random(true)}
            label={`seal-${i}`}
            setFile={handleSetSealCertificate}
            previewImage={previewImageSeal[i]}
            setPreviewImage={handleSetPreviewImageSeal}
            indexNumber={i}
            setType={handleSetSealCertificateType}
            type={sealCertificateType[i]}
          />
        );
      }
      return arrButton;
    };

    const handleSetBusinessLicense = (value, index) => {
      const tmpValue = [...businessLicense];
      // if (value) {
      //   tmpValue[index] = value;
      // } else {
      //   tmpValue.splice(index, 1);
      // }
      // Keep order, do not remove (splice) item from array
      tmpValue[index] = value;
      setBusinessLicense([...tmpValue]);
    };

    const handleSetBusinessLicenseType = (value, index) => {
      const tmpValue = [...businessLicenseType];
      // if (value) {
      //   tmpValue[index] = value;
      // } else {
      //   tmpValue.splice(index, 1);
      // }
      // Keep order, do not remove (splice) item from array
      tmpValue[index] = value;
      setBusinessLicenseType([...tmpValue]);
    };

    const handleSetPreviewImageLicense = (value, index) => {
      const tmpValue = [...previewImageLicense];
      // if (value) {
      //   tmpValue[index] = value;
      // } else {
      //   tmpValue.splice(index, 1);
      // }
      // Keep order, do not remove (splice) item from array
      tmpValue[index] = value;
      setPreviewImageLicense([...tmpValue]);
    };

    const handleSetBusinessLicenseName = (value, index) => {
      const tmpValueName = [...businessLicenseName];
      // if (value && value.trim() !== '') {
      //   tmpValueName[index] = value;
      // } else {
      //   tmpValueName.splice(index, 1);
      // }
      // Keep order, do not remove (splice) item from array
      tmpValueName[index] = value ? value.trim() : '';
      setBusinessLicenseName([...tmpValueName]);
    };

    const getBusinessLicenseButtons = () => {
      const arrButton = [];
      for (let i = 0; i < numberBusinessLicense; i += 1) {
        arrButton.push(
          <div key={random(true)}>
            <TextField
              label="詳細"
              fullWidth
              className={classes.textField}
              margin="normal"
              defaultValue={
                businessLicenseName[i] ? businessLicenseName[i] : ''
              }
              onBlur={e => {
                handleSetBusinessLicenseName(e.target.value, i);
              }}
            />
            <FileUpload
              label={`license-${i}`}
              setFile={handleSetBusinessLicense}
              previewImage={previewImageLicense[i]}
              setPreviewImage={handleSetPreviewImageLicense}
              indexNumber={i}
              setType={handleSetBusinessLicenseType}
              type={businessLicenseType[i]}
            />
          </div>
        );
      }
      return arrButton;
    };

    return (
      <div className={show ? null : classes.hidden}>
        <div className={classes.page}>
          <div className={classes.titleGroup}>
            <Typography component="h2" variant="h5">
              審査申請情報の入力
            </Typography>
          </div>

          <StepProgressBar currentStep={1} />

          <Paper className={classes.paper} elevation={1}>
            <div className={classes.pagerInDiv}>
              <RequiredButton />
              <Typography color="textPrimary" className={classes.mt20}>
                <span className={`${classes.bold} ${classes.font16}`}>
                  ③登記簿謄本
                </span>
                <br />
                <span className={classes.font12}>
                  必ず取得して1年以内のものを添付してください。
                  <br />
                  (ファイル形式：jpg,png,pdf)
                </span>
              </Typography>
              {getRegisterCopyButtons()}
              <AddMoreButton
                disabled={numberRegisterCopy >= 5}
                onClickAction={() =>
                  setNumberRegisterCopy(numberRegisterCopy + 1)
                }
              />
              <ValidationText message={registerCopyErr} />
            </div>
            <div className={classes.pagerInDiv}>
              <RequiredButton />
              <Typography color="textPrimary" className={classes.mt20}>
                <span className={`${classes.bold} ${classes.font16}`}>
                  ④印鑑証明
                </span>
                <br />
                <span className={classes.font12}>
                  必ず取得して1年以内のものを添付してください。
                  <br />
                  (ファイル形式：jpg,png,pdf)
                  <br />
                  ※①の登記簿謄本と同じ法人のものに限る
                </span>
              </Typography>
              {getSealCertificateButtons()}
              <AddMoreButton
                disabled={numberSealCertificate >= 5}
                onClickAction={() =>
                  setNumberSealCertificate(numberSealCertificate + 1)
                }
              />
              <ValidationText message={sealCertificateErr} />
            </div>
            <div className={classes.pagerInDiv}>
              <AnyButton />
              <Typography color="textPrimary" className={classes.mt20}>
                <span className={`${classes.bold} ${classes.font16}`}>
                  ⑤その他資料の添付
                </span>
                <br />
                <span className={classes.font12}>
                  住所変更や企業名変更・企業統合で登記簿と印鑑証明で異なる場合は詳細記載の上、内容証明できる資料を添付してください。
                </span>
              </Typography>
              {getBusinessLicenseButtons()}
              <AddMoreButton
                disabled={numberBusinessLicense >= 5}
                onClickAction={() =>
                  setNumberBusinessLicense(numberBusinessLicense + 1)
                }
              />
              <ValidationText message={businessLicenseErr} />
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <RequiredButton />
              <TextField
                required
                label="代表者名"
                fullWidth
                margin="normal"
                value={representativeName}
                onChange={e => {
                  setRepresentativeName(e.target.value);
                }}
                onBlur={validRepresentativeName}
              />
              <ValidationText message={representativeNameErr} />
            </div>
            <div className={classes.pagerInDiv}>
              <RequiredButton />
              <TextField
                required
                label="代表者名かな"
                fullWidth
                margin="normal"
                value={representativeNameKana}
                onChange={e => {
                  setRepresentativeNameKana(e.target.value);
                }}
                onBlur={validRepresentativeNameKana}
              />
              <ValidationText message={representativeNameKanaErr} />
            </div>
            <div className={classes.pagerInDiv}>
              <AnyButton />
              <TextField
                label="法人番号"
                type="number"
                placeholder="0123456789012"
                fullWidth
                margin="normal"
                value={companyCode}
                onChange={e => {
                  setCompanyCode(e.target.value);
                }}
              />
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <Typography variant="body2" color="textPrimary">
                注意点
                <br />
                ご購入者様の支払い方法としてPayPay決済もご用意しておりますが、法人の場合は管理システムへの反映に２週間〜１ヶ月ほどかかる場合がございます。
                <br />
                <br />
                店舗の審査基準
                <br />
                グループ機能を利用して店舗をご登録頂く場合でも、個別の店舗登録と同様に各店舗の審査がございます。下記の通りの審査基準となっておりますのでご了承ください。
                <br />
                <br />
                ・店舗の存在が確認でき、その本人（または責任者・社員）が登録していると判断できる事。
                <br />
                ・風営法の、風俗営業1号営業〜4号営業、性風俗関連特殊営業、を行っていない事。
              </Typography>
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                disabled={
                  !(
                    sealCertificate.length > 0 &&
                    registerCopy.length > 0 &&
                    representativeName &&
                    representativeNameKana
                  )
                }
                onClick={() => {
                  if (valid()) {
                    proceedToNext({ identityParams });
                  } else {
                    alert('登録情報を正しく入力してください。');
                  }
                }}
              >
                入力情報を確認
              </Button>
            </div>
          </Paper>
        </div>
        <div className={classes.linkToPrev}>
          {isReIdentity ? (
            <Button
              color="primary"
              onClick={() => {
                handleRedirect('/');
              }}
            >
              ログイン画面に戻る
            </Button>
          ) : (
            <Button color="primary" onClick={handleBack}>
              前の画面に戻る
            </Button>
          )}
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
